import React, { useEffect } from "react";
import CustomButtonNew from "Common/CustomButtonNew/CustomButtonNew";
import ReactPortal from "Components/ReactPortal/ReactPortal";
import PropTypes from "prop-types";
import ParamListGen from "Services/ParamListGen";
import api from "http";
import { ErrorHandlingMessage } from "Utils/ErrorHandlingMessage";
import { useState } from "react";
import NumberConversion from "Utils/NumberConversion";
import { DataGrid } from "Common/CusomReactGrid/CustomDataGrid";
import { toast } from "react-toastify";
import FullPageLoader from "Components/FullPageLoader/FullPageLoader";
import CustomDraggable from "Common/CustomDraggable/CustomDraggable";
import FormatMomentDate from "Utils/FormatMomentDate";
import Dropdown from "Common/DropDown/Dropdown";
import ThreeDotsIcon from "SVGS/ThreeDotsIcon";
const SEARCHMODEL = {
  dosfrom: "",
  dosto: "",
  addedfrom: "",
  addedto: "",
  patientid: "",
  patientName: "",
  status: "",
  statementstatus: "",
  type: "",
  InvoiceNumber: "",
  sendType: "",
};
const StatementPopup = ({ data, onClose, disableDraggable }) => {
  const uniqueId = "StatementPopup"
  const [Loader, setLoader] = useState(false);

  const [rows, setRows] = useState([]);
  const [paramModel, setParamModel] = useState({
    param_list: [],
    practiceId: 0,
    perPage: 20,
    pageNo: 1,
    totalPages: 0,
    totalCount: 0,
    isExportCall: false,
  });
  const handlePageChange = (pageNo) => {
    setParamModel((prev) => ({ ...prev, pageNo }));
  };
  const handlePerRowsChange = (perPage, pageNo) => {
    setParamModel((prev) => ({
      ...prev,
      pageNo,
      perPage
    }));
  };

  const linkToPatient = async (rowData) => {
    try {
      setLoader(true);
      const payload = {
        paymentMainId: data.id,
        patientStatementId: rowData.patientStatementId,
      };

      const response = await api.post(
        `${process.env.REACT_APP_TC_PMS}/api/PaymentStatement/LinkPaymentToInvoice`,
        payload
      );

      if (response.data.statusCode === 200) {
        toast.success(response.data.responseMessage);
        onClose();
      } else {
        toast.error(response.data.message);
      }
    } catch (error) {
      ErrorHandlingMessage(error);
    } finally {
      setLoader(false);
    }
  };

  const columns = [
    { name: "Patient", key: "patientName" },
    { name: "Account #", key: "patientAccountNumber" },
    { name: "Provider", key: "providerName" },
    {
      name: "Charges",
      key: "billedAmount",
      formatter: ({ row }) => <span>{NumberConversion(row.billedAmount)}</span>,
    },
    {
      name: "Patient Paid",
      key: "patientPaid",
      formatter: ({ row }) => <span>{NumberConversion(row.patientPaid)}</span>,
    },
    {
      name: "Patient Balance",
      key: "patientBalance",
      formatter: ({ row }) => (
        <span>{NumberConversion(row.patientBalance)}</span>
      ),
    },
    {
      name: "Patient Credit",
      key: "patientCredits",
      formatter: ({ row }) => (
        <span>{NumberConversion(row.patientCredits)}</span>
      ),
    },
    {
      name: "Ins. Adjustment",
      key: "insuranceAdjustment",
      formatter: ({ row }) => (
        <span>{NumberConversion(row.insuranceAdjustment)}</span>
      ),
    },
    {
      name: "Sent Date",
      key: "lastStatementDate",
      width: 100,
      formatter: ({ row }) => FormatMomentDate(row.lastStatementDate)

    },
    {
      width: 80,
      name: "Action",
      key: "",
      formatter: ({ row }) => {
        return (
          <div className='flex items-center justify-center h-full'>
            <Dropdown>
              <Dropdown.Button>
                <ThreeDotsIcon />
              </Dropdown.Button>
              <Dropdown.Menu align='end'>
                <Dropdown.MenuItem className="group rdx_item" onSelect={() => linkToPatient(row)} > Link to Invoice </Dropdown.MenuItem>
              </Dropdown.Menu>
            </Dropdown>
          </div>
        );
      },

    },
  ];

  useEffect(() => {
    (async () => {
      try {
        setLoader(true);
        const payload = {
          param_list: ParamListGen({
            ...SEARCHMODEL,
            statementstatus: "sent",
            patientid: data.patientId,
          }),
          practiceId: 0,
          perPage: paramModel.perPage,
          pageNo: paramModel.pageNo,
          totalPages: 0,
          totalCount: 0,
          isExportCall: false,
        };
        const response = await api.post(
          `${process.env.REACT_APP_TC_PMS}/api/PatientStatement/FindPatientStatements`,
          payload
        );
        setParamModel((prev) => ({
          ...prev,
          totalCount: response.data.dataModel.totalCount,
        }));
        setRows(response.data.dataModel.data);
      } catch (error) {
        ErrorHandlingMessage(error);
      } finally {
        setLoader(false);
      }
    })();
  }, [paramModel.pageNo, paramModel.perPage, data.patientId]);

  return (
    <ReactPortal wrapperId={uniqueId}>
      {Loader && <FullPageLoader allowFullScreen />}
      <div
        data-te-modal-init
        className="fixed inset-0 z-10 flex items-center justify-center bg-gray-500 bg-opacity-75"
        id="exampleModalScrollable"
        tabIndex={-1}
        aria-labelledby="exampleModalScrollableLabel"
        aria-modal="true"
        data-te-open="true"
      >
        <CustomDraggable disableDraggable={disableDraggable} handle={`#${uniqueId}`}>
          <div
            data-te-modal-dialog-ref
            className="relative w-[1140px] min-[576px]:mx-auto min-[576px]:mt-2 min-[576px]:max-w-[500px] min-[992px]:max-w-[800px] min-[1200px]:max-w-[1140px] flex flex-col overflow-hidden rounded-md bg-white shadow-lg"
          >
            {/* Header */}
            <div
              id={uniqueId}
              className="flex items-center justify-between p-5 text-2xl font-semibold border-b cursor-grab"
            >
              Link with Patient Statement
              <button onClick={onClose} className="p-1.5 shrink-0 rounded border border-slate-200 hover:border-slate-300 shadow-sm ml-2">
                <img src="/img/crossblack.svg" alt="cross" />
              </button>
            </div>
            <div className="px-5 pt-5 overflow-y-auto max-h-[70vh]">
              <DataGrid
                columns={columns}
                rows={rows}
                pagination={{
                  perPage: paramModel.perPage,
                  pageNo: paramModel.pageNo,
                  totalCount: paramModel.totalCount,
                }}
                selectColumn={false}
                manualPagination={true}
                handlePerRowsChange={handlePerRowsChange}
                handlePageChange={handlePageChange}
                dynamicClass="allowDropDown"
                mainDivClass="patientStatementDynamicClass"
                height="100%"
              />
            </div>

            {/* Footer */}
            <div className="flex flex-wrap items-center justify-end gap-2 p-5 ">
              <CustomButtonNew label="Cancel" variant="outline" onClick={onClose} />
            </div>
          </div>
        </CustomDraggable>
      </div>
    </ReactPortal>
  );
};

export default StatementPopup;

StatementPopup.propTypes = {
  onClose: PropTypes.func.isRequired,
};
